import React, { useState } from 'react'
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import AnimateHeight from 'react-animate-height'
import styles from './dropdown.module.scss'
import { ERCText } from 'components/text';

const Dropdown = ({ header, smallText, }) => {

    const [toggle, setToggle] = useState(false)

    return (
        <div className={styles.body} >
            <div className={styles.container} >
                <ul className={styles.ulist}>
                    <li className={styles.list} >
                        <div className={styles.toggle} style={{ background: `${toggle ? '#00296B' : '#fff'}`, }} onClick={() => setToggle(!toggle)}>

                            <ERCText color={`${toggle ? '#fff' : '#00296B'}`} inline={false} lHeight='24px' size='16px' weight='600'  >{header}</ERCText>
                            {toggle ? <AiOutlineMinus style={{ cursor: 'pointer', display: 'block', color: `${toggle ? '#fff' : '#00296B'}` }} /> : <AiOutlinePlus style={{ cursor: 'pointer', display: 'block', color: `${toggle ? '#fff' : '#00296B'}` }} />}
                        </div>
                    </li>
                </ul>
                <AnimateHeight
                    id="example-panel"
                    duration={500}
                    height={toggle ? 'auto' : 0} // see props documentation below
                >

                    <ERCText style={{ padding: '24px 24px' }} weight='400' size='20px' width='auto' lHeight='24px' align='justify' color='#0C0C0C'>
                        {smallText}
                    </ERCText>
                </AnimateHeight>
            </div>

        </div>

    )
}

export default Dropdown